import GridWrapper from './component/GridWrapper'
import GridItem from './component/GridItem'
import GridItemSmall from './component/GridItemSmall'

/**
 * A simple inline-block based responsive grid, with two possible
 * interfaces for creating column widths.
 */

const Grid = GridWrapper
Grid.displayName = 'Grid'

Grid.Item = GridItem
Grid.Item.displayName = 'Grid.Item'

Grid.ItemSmall = GridItemSmall
Grid.ItemSmall.displayName = 'Grid.ItemSmall'

export default Grid
